@if (dispatchCampaign(); as dispatchCampaign) {
    @if (!clientsLoading()) {
        <div (animate.enter)="animateStepIn($event)">
            <div class="flex! flex-col! justify-start items-center gap-3! w-full" (animate.enter)="animateStepIn($event)">
                @for (condition of dispatchCampaign.targetFilter.conditions; track condition; let index = $index) {
                    <section class="flex! flex-col! w-full">
                        <p-card class="p-none!">
                            <ng-template #header>
                                <section class="w-full border-b-2 border-b-border! py-2 px-4">
                                    <div class="flex! gap-2 items-center">
                                        <div>
                                            <i class="pi pi-angle-up neutral clickable" (click)="moveConditionUp(condition)"></i>
                                            <i class="pi pi-angle-down neutral clickable" (click)="moveConditionDown(condition)"></i>
                                        </div>

                                        <div class="col-auto">
                                            <p-badge severity="secondary" badgeSize="xlarge" [value]="index + 1" />
                                        </div>

                                        <div class="col">
                                            <p-select
                                                class="w-full"
                                                appendTo="body"
                                                size="large"
                                                [(ngModel)]="condition.action"
                                                [options]="[
                                                    { label: ('INCLUDE' | translate), value: 'INCLUDE' },
                                                    { label: ('EXCLUDE' | translate), value: 'EXCLUDE' }
                                                ]" />
                                        </div>

                                        <div class="col">
                                            <p-select
                                                class="w-full"
                                                [(ngModel)]="condition.type"
                                                appendTo="body"
                                                size="large"
                                                (onChange)="conditionTypeChanged(condition)"
                                                [options]="[
                                                    { label: ('TARGET_FILTER_ALL_CUSTOMERS' | translate), value: 'ALL_CUSTOMERS' },
                                                    { label: ('TARGET_FILTER_SPECIFIC_BOOKINGS' | translate), value: 'SPECIFIC_BOOKINGS' }
                                                ]" />
                                        </div>

                                        <div class="col">
                                            <p-select
                                                class="w-full"
                                                [(ngModel)]="condition.clientId"
                                                (onChange)="clientIdChanged(condition)"
                                                [options]="clients()"
                                                optionValue="id"
                                                size="large"
                                                appendTo="body"
                                                optionLabel="name" />
                                        </div>
                                        <div
                                            class="w-8 aspect-square rounded-full bg-surface-sunk hover:bg-surface flex! justify-center items-center transition-all">
                                            <i class="ph ph-x negative clickable" (click)="removeCondition(condition)"></i>
                                        </div>
                                    </div>
                                </section>
                            </ng-template>
                            <section class="flex flex-col gap-4">
                                @if (condition.clientId; as clientId) {
                                    <div class="flex flex-col gap-4" (animate.enter)="animateStepIn($event)">
                                        <!-- ALL_CUSTOMERS -->
                                        @if (condition.type == 'ALL_CUSTOMERS' && condition.data.ALL_CUSTOMERS; as allCustomers) {
                                            <div class="row" (animate.enter)="animateStepIn($event)">
                                                <div class="col flex! items-center gap-2!">
                                                    <p-toggleswitch [(ngModel)]="allCustomers.newsletterAcceptedOnly"></p-toggleswitch>
                                                    <label>{{ 'NEWSLETTER_ACCEPTED_ONLY' | translate }}</label>
                                                </div>
                                            </div>
                                        }

                                        <!-- SPECIFIC_BOOKINGS -->
                                        @if (
                                            condition.type == 'SPECIFIC_BOOKINGS' && condition.data.SPECIFIC_BOOKINGS;
                                            as specificBookings
                                        ) {
                                            <section>
                                                <p class="text-sm">{{ 'DATE_FILTERS' | translate }}</p>
                                            </section>

                                            <!-- VISIT DATE -->
                                            <div class="flex! items-center justify-start gap-2" (animate.enter)="animateStepIn($event)">
                                                <div class="min-w-40 flex! items-center gap-2!">
                                                    <p-toggleswitch [(ngModel)]="specificBookings.visitDate.enabled"></p-toggleswitch>
                                                    <label>{{ 'VISIT_DATE' | translate }}</label>
                                                </div>

                                                <p-datepicker
                                                    class="w-full"
                                                    fluid
                                                    [(ngModel)]="specificBookings.visitDate.start"
                                                    placeholder="{{ 'START_DATE' | translate }}"
                                                    iconDisplay="input"
                                                    [disabled]="!specificBookings.visitDate.enabled"
                                                    size="large"
                                                    [showIcon]="true" />

                                                <p>to</p>

                                                <p-datepicker
                                                    class="w-full"
                                                    fluid
                                                    [(ngModel)]="specificBookings.visitDate.end"
                                                    placeholder="{{ 'END_DATE' | translate }}"
                                                    iconDisplay="input"
                                                    size="large"
                                                    [disabled]="!specificBookings.visitDate.enabled"
                                                    [showIcon]="true" />
                                            </div>

                                            <hr class="border-border" />

                                            <!-- BOOKING DATE -->
                                            <div class="flex! items-center justify-start gap-2" (animate.enter)="animateStepIn($event)">
                                                <div class="min-w-40 flex! items-center gap-2!">
                                                    <p-toggleswitch [(ngModel)]="specificBookings.bookingDate.enabled"></p-toggleswitch>
                                                    <label>{{ 'BOOKING_DATE' | translate }}</label>
                                                </div>

                                                <p-datepicker
                                                    class="w-full"
                                                    fluid
                                                    [(ngModel)]="specificBookings.bookingDate.start"
                                                    placeholder="{{ 'START_DATE' | translate }}"
                                                    iconDisplay="input"
                                                    size="large"
                                                    [disabled]="!specificBookings.bookingDate.enabled"
                                                    [showIcon]="true" />

                                                <p>to</p>
                                                <p-datepicker
                                                    class="w-full"
                                                    fluid
                                                    [(ngModel)]="specificBookings.bookingDate.end"
                                                    placeholder="{{ 'END_DATE' | translate }}"
                                                    iconDisplay="input"
                                                    size="large"
                                                    [disabled]="!specificBookings.bookingDate.enabled"
                                                    [showIcon]="true" />
                                            </div>

                                            <!-- OPTIONS ROW -->
                                            <section class="mt-2">
                                                <p class="text-sm">Options</p>
                                            </section>

                                            <div class="flex! gap-2 justify-start! items-center" (animate.enter)="animateStepIn($event)">
                                                <div class="min-w-40 flex! items-center gap-2!">
                                                    <p-toggleswitch [(ngModel)]="specificBookings.includeInvitedpeople"></p-toggleswitch>
                                                    <label>{{ 'INCLUDE_INVITES' | translate }}</label>
                                                </div>
                                                <div class="border-r-2! h-8! border-border"></div>

                                                <div class="min-w-40 flex! items-center gap-2!">
                                                    <p-toggleswitch [(ngModel)]="specificBookings.newsletterAcceptedOnly"></p-toggleswitch>
                                                    <label>{{ 'NEWSLETTER_ACCEPTED' | translate }}</label>
                                                </div>
                                                <div class="border-r-2! h-8! border-border"></div>

                                                <div class="col-4 w-full!">
                                                    @if (availablePackagesByClient[clientId]; as packages) {
                                                        <p-select
                                                            class="w-full!"
                                                            fluid
                                                            [options]="packages"
                                                            [(ngModel)]="specificBookings.packageIds"
                                                            [multiple]="true"
                                                            size="large"
                                                            [filter]="false"
                                                            appendTo="body"
                                                            optionLabel="name"
                                                            optionValue="id"
                                                            placeholder="{{ 'PACKAGES' | translate }}" />
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </section>
                        </p-card>
                    </section>
                }
            </div>

            <!-- ADD CONDITION -->
            <div class="row">
                <div class="col-12 align-center">
                    <br />
                    <button pButton type="button" severity="success" (click)="addCondition()">
                        {{ 'ADD_CONDITION' | translate }}
                    </button>
                </div>
            </div>
        </div>
    }

    @if (clientsLoading()) {
        <div (animate.enter)="animateStepIn($event)">
            <!-- Skeleton: mimics a single condition card while loading -->
            <p-card class="condition shadow-lg border border-border">
                <!-- Header row skeleton -->
                <div class="condition-header">
                    <div class="row">
                        <div class="col-auto">
                            <p-skeleton shape="circle" size="2rem" />
                        </div>
                        <div class="col">
                            <p-skeleton width="100%" height="2.5rem" borderRadius="6px" />
                        </div>
                        <div class="col">
                            <p-skeleton width="100%" height="2.5rem" borderRadius="6px" />
                        </div>
                        <div class="col">
                            <p-skeleton width="100%" height="2.5rem" borderRadius="6px" />
                        </div>
                        <div class="col-auto">
                            <p-skeleton width="5rem" height="2.5rem" borderRadius="6px" />
                        </div>
                    </div>
                </div>

                <!-- Body rows skeleton -->
                <div class="row">
                    <div class="col-4">
                        <p-skeleton width="70%" height="1.25rem" borderRadius="4px" />
                    </div>
                    <div class="col-4">
                        <p-skeleton width="100%" height="2.5rem" borderRadius="6px" />
                    </div>
                    <div class="col-4">
                        <p-skeleton width="100%" height="2.5rem" borderRadius="6px" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <p-skeleton width="70%" height="1.25rem" borderRadius="4px" />
                    </div>
                    <div class="col-4">
                        <p-skeleton width="100%" height="2.5rem" borderRadius="6px" />
                    </div>
                    <div class="col-4">
                        <p-skeleton width="100%" height="2.5rem" borderRadius="6px" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <p-skeleton width="60%" height="1.25rem" borderRadius="4px" />
                    </div>
                    <div class="col-4">
                        <p-skeleton width="60%" height="1.25rem" borderRadius="4px" />
                    </div>
                    <div class="col-4">
                        <p-skeleton width="100%" height="2.5rem" borderRadius="6px" />
                    </div>
                </div>
            </p-card>
        </div>
    }
}
